import script from './icon.vue_vue_type_script_lang.mjs';
export { default } from './icon.vue_vue_type_script_lang.mjs';
import { render } from './icon.vue_vue_type_template_id_89b755b6_lang.mjs';

script.render = render;
script.__file = "packages/components/icon/src/icon.vue";
//# sourceMappingURL=icon2.mjs.map
